<script setup>
import {computed, inject} from "vue";
import useComment, {USE_COMMENT_KEY} from "./CommentComposition";
import CommentThreadResponse from "./CommentThreadResponse.vue";
import useHeightTransition from "./HeightTransitionComposition";
const siteUrl = document.querySelector('meta[name="site-url"]').content;

const props = defineProps({
  thread: {
    type: Array,
    required: true
  },
  isSelf: {
    type: Boolean,
    required: true
  },
  commentEmpathy: {
    type: Array,
    required: true
  },
  commentViolations: {
    type: Array,
    required: true
  },
});

const emits = defineEmits(['delete-comment']);

//コンポジションを定義、配信
const composition = inject(USE_COMMENT_KEY, useComment());
const heightTransition = useHeightTransition();

//先頭のみ抜かしたスレッド
const commentsAfterSeconds = computed(() => props.thread.filter((_, index) => index !== 0));

//スレッドを開く
const openThread = () => {
  heightTransition.open();
};

//自身のコメントが含まれているスレッドは開いておく
if (props.isSelf) {
  heightTransition.open();
}
</script>

<template>
  <div
    v-if="thread.length > 0"
    class="lyMb16 pBackColorWhite pBorderRadius4px"
  >
    <CommentThreadResponse
      :comment-violations="commentViolations"
      :comment-empathy="commentEmpathy"
      :thread="thread"
      :comment="thread[0]"
      :index="0"
      @delete-comment="emits('delete-comment', $event)"
      @open-thread="openThread"
    />
    <div class="lyColumn">
      <button
        v-if="thread.length > 1"
        type="button"
        class="lyOrder1 lyHvCnt lyPt12 lyPb12 lyW100 pFont12 pFontBold pBorderTop2pxSolidGray4 pageBoardThreadTrigger"
        @click="heightTransition.toggle"
      >
        {{heightTransition.isOpen.value ? 'スレッドを閉じる' : 'スレッドを見る'}}
        <span
          :style="heightTransition.isOpen.value ? 'transform:rotate(180deg)' : ''"
          class="lyBlock lyW16px lyMl8 pAnimation modBasicToggleArrow"
        >
        <img
          :src="siteUrl+'images/btnIconDownArrowBlack.svg'"
          width="16"
          height="16"
          loading="lazy"
          alt=""
        >
      </span>
      </button>
      <transition
        name="thread"
        @enter="heightTransition.onEnter"
        @after-enter="heightTransition.onAfter"
        @leave="heightTransition.onLeave"
        @after-leave="heightTransition.onAfter"
      >
        <div
          v-if="heightTransition.isOpen.value"
          class="lyOrder0 lyPl8"
        >
          <div>
            <div
              v-for="(comment, index) in commentsAfterSeconds"
              :key="comment.id"
              class="pBorderLeft1pxSolidBlack pBorderTop1pxSolidGray4"
            >
              <CommentThreadResponse
                :comment-violations="commentViolations"
                :comment-empathy="commentEmpathy"
                :thread="thread"
                :comment="comment"
                :index="index + 1"
                @delete-comment="emits('delete-comment', $event)"
                @open-thread="openThread"
              />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style scoped>
.thread-enter-active,
.thread-leave-active {
  transition: height 0.5s ease;
  height: auto;
}
</style>
